import React from "react";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  Button,
  Menu,
  MenuItem,
  ThemeProvider,
  createTheme,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";

import i18n from "i18next";
import English from "../../assets/imgs/countries/english.png";
import Vietnam from "../../assets/imgs/countries/vietnam.png";

const theme = createTheme({
  palette: {
    button: {
      color: "#3A505F",
    },
  },
});
const StyleButton = styled(Button)(() => ({
  color: "#3A505F",
  fontSize: "14px",
  fontWeight: "400",
  backgroundColor: "transparent",
  textTransform: "capitalize",
  "&:hover": {
    backgroundColor: "transparent",
  },
}));
const MenuStyle = styled(Menu)(() => ({
  "& .MuiList-root": {
    backgroundColor: "#F1F6FA",
    paddingTop: "0",
    color: "#3A505F",
    paddingBottom: "0",
  },
  "& .MuiPaper-root": {
    backgroundColor: "#F1F6FA",
  },
}));
export const LanguageMenu = () => {
  const handleLanguage = (lang, popupState) => {
    if (popupState) {
      popupState.close();
    }

    i18n.changeLanguage(lang);
    window.location.assign(
      process.env.PUBLIC_URL + (lang === "en" ? "/en" : "/vi"),
    );
  };

  return (
    <ThemeProvider theme={theme}>
      <PopupState variant="popover" popupId="demo-popup-menu" sx={{ py: "0" }}>
        {(popupState) => (
          <React.Fragment>
            <StyleButton success={true} variant="" {...bindTrigger(popupState)}>
              <img
                src={
                  (i18n.language === "en" && English) ||
                  (i18n.language === "vi" && Vietnam)
                }
                alt=""
                style={{ width: "24px", marginRight: "5px" }}
              />
              <p className="text-[#3D2E7C]">
                {" "}
                {i18n.language === "en" ? "English" : "Tiếng Việt"}
              </p>
              <KeyboardArrowDownIcon sx={{ color: "#3D2E7C" }} />
            </StyleButton>
            <MenuStyle
              {...bindMenu(popupState)}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "center",
                horizontal: "right",
              }}
            >
              <MenuItem
                onClick={() => {
                  handleLanguage("en", popupState);
                }}
                style={{ fontSize: "14px", width: "160px", color: "#3D2E7C" }}
              >
                <img
                  src={English}
                  alt=""
                  style={{ width: "30px", marginRight: "10px" }}
                />
                English
              </MenuItem>
              <MenuItem
                onClick={() => {
                  handleLanguage("vi", popupState);
                }}
                style={{
                  fontSize: "14px",
                  color: "#3D2E7C",
                }}
              >
                <img
                  src={Vietnam}
                  alt=""
                  style={{ width: "30px", marginRight: "10px" }}
                />
                Tiếng Việt
              </MenuItem>
            </MenuStyle>
          </React.Fragment>
        )}
      </PopupState>
    </ThemeProvider>
  );
};
